import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate, useParams, Link, useSearchParams } from "react-router-dom";
import AlertMessage from "../include/AlertMessage";
import { storage, ID, Permission, Role } from "../../appwrite/config";
var _ = require('lodash');

function EditCoupon() {
    const [searchParams] = useSearchParams();
    const page = searchParams.get("page") || 1;

    const [alert, setAlert] = useState({ type: "", message: "" });
    const [formData, setformData] = useState({ shopid: '', code: '', description: '', expiryDate: '', isActive: false });
    const [errors, setErrors] = useState({});
    const [allShops, setShops] = useState([]);
    const [loading, setLoading] = useState(true);
    const redirectHistory = useNavigate();
    const { id } = useParams();
    const token = sessionStorage.getItem('JWT_TOKEN');
    const [image, setImage] = useState(null);
    const [oldImage, setOldImage] = useState("");

    const validate = () => {
        const newErrors = {};
        if (!formData.shopid) newErrors.shopid = "Shop is required.";
        if (!formData.code) {
            newErrors.code = "Code is required.";
        }
        if (formData.code.length > 10) {
            newErrors.code = "Code cannot be more than 10 characters.";
        }
        if (!formData.description) newErrors.description = "Description is required.";
        if (!formData.expiryDate) newErrors.expiryDate = "Expiry Date is required.";
        return newErrors;
    };


    // Define an async function inside useEffect
    const fetchData = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_URL}/getcoupondetail/${id}`, {
                headers: {
                    'Authorization': 'Bearer ' + token // Replace with your token
                }
            });

            const resdata = response.data.data;

            //convert coupon expire date to YYYY-MM-DD
            const myDate = new Date(resdata.expiryDate);
            const expdate = myDate.toISOString().split('T')[0]; // '2025-05-23'
            const customdata = {
                shopid: resdata.shops,
                code: resdata.code,
                description: resdata.description,
                expiryDate: expdate,
                isActive: resdata.isActive
            }
            setformData(customdata); // Set data to state
            // OLD IMAGE
            if (resdata.imageID) {

                setOldImage(resdata.imageID);

                setImage({
                    preview: storage
                        .getFilePreview(
                            process.env.REACT_APP_BUCKET_ID,
                            resdata.imageID
                        )
                        .toString()
                });
            }
        } catch (error) {
            const apierror = _.get(error, ['response', 'data', 'error', 'message'], "Something went wrong");
            setAlert({ type: "error", message: apierror });
        } finally {
            setLoading(false);
        }
    };

    const fetchAllShops = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_URL}/shops/dropdown`,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + token
                    }
                }
            );

            const shopsdata = await response.data;            
            if (Array.isArray(shopsdata.data) && shopsdata.data.length > 0 && Array.isArray(shopsdata.data)) {
                setShops(shopsdata.data);
            } else {
                setShops([]);
            }

        } catch (err) {
            const apierror = _.get(err, ['response', 'data', 'error', 'message'], "Something went wrong");
            setAlert({ type: "error", message: apierror });
        } finally {
            setLoading(false);
        }

    };

    useEffect(() => {
        fetchData(); // Call the async function    
        fetchAllShops();
    }, [id]);


    const handleChange = (e) => {
        setformData({ ...formData, [e.target.name]: (e.target.type === 'checkbox') ? e.target.checked : e.target.value });
    };

    // ✅ SINGLE FILE HANDLER
    const handleFileChange = (e) => {
        const file = e.target.files[0];

        if (!file) return;

        const allowedTypes = ["image/jpeg", "image/png", "image/jpg", "image/webp"];
        const maxSize = 5 * 1024 * 1024; // 5MB

        // ❌ TYPE CHECK
        if (!allowedTypes.includes(file.type)) {
            setAlert({
                type: "error",
                message: "Only JPG, PNG, WEBP images are allowed."
            });
            return;
        }

        // ❌ SIZE CHECK
        if (file.size > maxSize) {
            setAlert({
                type: "error",
                message: "Image size must be less than 5MB."
            });
            return;
        }

        // ✅ VALID FILE
        setImage({
            file: file,
            preview: URL.createObjectURL(file)
        });
    };

    const handleRemoveImage = () => {
        const confirmDelete = window.confirm("Are you sure you want to delete this image?");
        if (!confirmDelete) return;

        setImage(null);
        setOldImage("");
    };

    const handleEdit = async (e) => {
        e.preventDefault();
        setLoading(true);
        const newErrors = validate();
        setErrors(newErrors);
        if (Object.keys(newErrors).length === 0) {
            try {
                let fileId = oldImage;

                if (image?.file) {

                    // DELETE OLD IMAGE
                    if (oldImage) {

                        try {

                            await storage.deleteFile(
                                process.env.REACT_APP_BUCKET_ID,
                                oldImage
                            );

                        } catch (err) {
                            console.error(err);
                        }

                    }

                    // UPLOAD NEW IMAGE
                    const uploadedFile = await storage.createFile(
                        process.env.REACT_APP_BUCKET_ID,
                        ID.unique(),
                        image.file,
                        [
                            Permission.read(Role.any()),
                            Permission.write(Role.any())
                        ]
                    );

                    fileId = uploadedFile.$id;
                }

                const response = await axios.put(`${process.env.REACT_APP_API_URL}/editcoupon/${id}`,
                    {
                        "shopID": formData.shopid,
                        "code": formData.code,
                        "description": formData.description,
                        "expiryDate": formData.expiryDate,
                        "isActive": formData.isActive,
                        "image": fileId
                    },
                    {
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': 'Bearer ' + token // Replace with your token
                        }
                    }
                );

                if (response.status === 200 || response.status === 201) {
                    setAlert({ type: "success", message: "Coupon updated successfully." });
                    setTimeout(() => redirectHistory(`/coupons?page=${page}`), 2500); // thoda delay take redirect to listing page    
                }

            } catch (err) {
                const apierror = _.get(err, ['response', 'data', 'error', 'message'], "Failed to edit coupon. Please try again.");
                setAlert({ type: "error", message: apierror });

            } finally {
                setTimeout(() => {
                    setLoading(false);
                }, 1000);
            }
        }
    };

    return (
        <section>
            <div className="is-title-bar">
                <div className="flex flex-col md:flex-row items-center justify-between space-y-6 md:space-y-0">
                    <ul>
                        <li><Link to="/dashboard" className='btn btn-primary'>Dashboard</Link></li>
                        <li><Link to="/coupons" className='btn btn-primary'>Coupons</Link></li>
                        <li>Edit</li>
                    </ul>
                </div>
            </div>
            <div className="section main-section">
                <div className="grid gap-6 grid-cols-1 md:grid-cols-12">
                    <div className="card">
                        <header className="card-header">
                            <p className="card-header-title">
                                <span className="icon"><i className="mdi mdi-reorder-horizontal"></i></span>
                                Edit Coupon
                            </p>
                        </header>
                        <div className="card-content">
                            {loading ? (
                                <div className="flex justify-center items-center py-10">
                                    <div className="animate-spin rounded-full h-12 w-12 border-t-4 border-blue-500 border-solid"></div>
                                </div>

                            ) : (
                                <form onSubmit={handleEdit}>
                                    {alert.message && (
                                        <AlertMessage
                                            type={alert.type}
                                            message={alert.message}
                                            onClose={() => setAlert({ type: "", message: "" })}
                                        />
                                    )}

                                    <div className="grid sm:gap-0 md:gap-6 md:grid-cols-2 sm:grid-cols-1 sm:mb-3">
                                        <div className="field">
                                            <label className="label">Select Shop <span style={{ color: "red" }}>*</span></label>
                                            <div className="control">
                                                <div className="select">
                                                    <select name="shopid" id="shopid" value={formData.shopid || ""} onChange={handleChange}>
                                                        <option value={''}>---Select---</option>
                                                        {allShops.map((shop, index) => (
                                                            <option key={index} value={shop.$id}>
                                                                {shop.name}
                                                            </option>
                                                        ))}
                                                    </select>
                                                    {errors.shopid && <p className="help" style={{ color: 'red' }}>{errors.shopid}</p>}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="field">
                                            <label className="label">Code <span style={{ color: "red" }}>*</span></label>
                                            <div className="control">
                                                <input className="input" id="code" type="text" placeholder="Code" name="code" value={formData.code} onChange={handleChange}  maxLength={10} />
                                            </div>
                                            {errors.code && <p className="help" style={{ color: 'red' }}>{errors.code}</p>}
                                        </div>
                                    </div>
                                    <div className="grid sm:gap-0 md:gap-6 md:grid-cols-2 sm:grid-cols-1 sm:mb-3">
                                        <div className="field">
                                            <label className="label">Expiry Date <span style={{ color: "red" }}>*</span></label>
                                            <div className="control">
                                                <input className="input" id="expiryDate" name="expiryDate" type="date" placeholder="Expiry Date" value={formData.expiryDate} onChange={handleChange} />
                                            </div>
                                            {errors.expiryDate && <p className="help" style={{ color: 'red' }}>{errors.expiryDate}</p>}
                                        </div>
                                        <div className="field">
                                            <label className="label">Image</label>
                                            <div className="control">
                                                <input className="input" id="simage" accept="image/*" type="file" onChange={handleFileChange} />
                                            </div>
                                            {errors.simage && <p className="help" style={{ color: 'red' }}>{errors.simage}</p>}
                                        </div>
                                    </div>

                                    <div className="grid sm:gap-0 md:gap-6 md:grid-cols-1 sm:grid-cols-1 sm:mb-3">

                                        {image && (
                                            <div className="card">
                                                <header className="card-header">
                                                    <p className="card-header-title">
                                                        Image Preview
                                                    </p>
                                                </header>

                                                <div className="card-content">
                                                    <div style={{
                                                        display: "flex",
                                                        flexWrap: "wrap",
                                                        gap: "15px"
                                                    }}>
                                                        <div style={{
                                                            position: "relative",
                                                            width: "120px",
                                                            height: "100px"
                                                        }}>
                                                            {/* DELETE BUTTON */}
                                                            <button
                                                                type="button"
                                                                onClick={handleRemoveImage}
                                                                style={{
                                                                    position: "absolute",
                                                                    top: "-8px",
                                                                    right: "-8px",
                                                                    background: "red",
                                                                    color: "#fff",
                                                                    border: "none",
                                                                    borderRadius: "50%",
                                                                    width: "22px",
                                                                    height: "22px",
                                                                    cursor: "pointer",
                                                                    fontSize: "12px",
                                                                    zIndex: 10
                                                                }}
                                                            >
                                                                ✕
                                                            </button>

                                                            {/* IMAGE */}
                                                            <img
                                                                src={image.preview}
                                                                alt="preview"
                                                                style={{
                                                                    width: "100%",
                                                                    height: "100%",
                                                                    objectFit: "cover",
                                                                    borderRadius: "6px",
                                                                    border: "1px solid #ddd"
                                                                }}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                    </div>

                                    <div className="field">
                                        <label className="label">Description <span style={{ color: "red" }}>*</span></label>
                                        <div className="control">
                                            <textarea className="textarea" id="description" name="description" placeholder="Description" value={formData.description} onChange={handleChange} ></textarea>
                                        </div>
                                        {errors.description && <p className="help" style={{ color: 'red' }}>{errors.description}</p>}
                                    </div>
                                    <div className="field spaced">
                                        <div className="control">
                                            <label className="checkbox label"><input type="checkbox" name="isActive" id="isActive" checked={formData.isActive} onChange={handleChange} />
                                                <span className="check"></span>
                                                <span className="control-label">Active</span>
                                            </label>
                                        </div>
                                    </div>
                                    <div className="flex justify-center items-center">
                                        <div className="field grouped">
                                            <div className="control">
                                                <button type="submit" className="button green">
                                                    Submit
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default EditCoupon;